import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowDownIcon, MenuIcon, XIcon } from "lucide-react";
import { BrandMark } from "../brand/BrandMark";
import { navLinks } from "../../data/content";
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);
  const close = () => setOpen(false);
  return <header className="sticky top-0 z-40 border-b border-white/10 bg-navy/95 backdrop-blur" data-id="element-55" data-mp="g13z588jbt9w">
      <div className="container-x flex h-16 items-center justify-between gap-6" data-id="element-56" data-mp="kyc8qkfmaozj">
        <a href="#top" className="flex items-center gap-2.5 text-ice" onClick={close} data-id="element-57" data-mp="pzji2nxerw8b">
          <BrandMark data-id="element-58" data-mp="uxbik6c4cqo4" />
          <span className="font-display text-[22px] font-bold tracking-[0.01em]" data-id="element-59" data-mp="uymly51njwep">
            FloorHockey<span className="text-cyan" data-id="element-60" data-mp="1v9iptaw4s37">ClassReady</span>
          </span>
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-8 md:flex" data-id="element-61" data-mp="3t09nsbsp5pdz">
          {navLinks.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-[14px] font-semibold text-ice/75 transition-colors duration-150 hover:text-ice" data-id="element-62" data-mp="3o27teuptm3n7">
              {link.label}
            </a>)}
          <a href="#offer" className="btn-small" data-id="element-63" data-mp="fl4q4mu376et">
            See the bundle
            <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-64" data-mp="auwn8nyx2e0h" />
          </a>
        </nav>

        <button type="button" className="-mr-2 inline-flex h-11 w-11 items-center justify-center rounded-full text-ice md:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? "Close menu" : "Open menu"} onClick={() => setOpen(v => !v)} data-id="element-65" data-mp="6tb44kvsh3hu">
          {open ? <XIcon className="h-6 w-6" data-id="element-66" data-mp="2stdz4d1loxm8" /> : <MenuIcon className="h-6 w-6" data-id="element-67" data-mp="2st4j9ia9s6u9" />}
        </button>
      </div>

      <AnimatePresence initial={false} data-id="element-68" data-mp="2xqe74ti0gafz">
        {open && <motion.nav id="mobile-nav" aria-label="Mobile" initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-white/10 bg-navy md:hidden" data-id="element-69" data-mp="2j2jgdinkcg5j">
            <ul className="container-x py-3" data-id="element-70" data-mp="2f2981zcatdni">
              {navLinks.map(link => <li key={link.href} className="border-b border-white/10" data-id="element-71" data-mp="2058edqajr8me">
                  <a href={link.href} onClick={close} className="block py-4 font-display text-2xl font-bold uppercase text-ice" data-id="element-72" data-mp="251yvmgy38a9e">
                    {link.label}
                  </a>
                </li>)}
              <li className="pb-4 pt-5" data-id="element-73" data-mp="1nso9gs2oifkq">
                <a href="#offer" onClick={close} className="btn-primary w-full justify-center" data-id="element-74" data-mp="1ntpmh2399c53">
                  See the bundle
                  <ArrowDownIcon className="h-5 w-5" aria-hidden="true" data-id="element-75" data-mp="1xizb27yw4cog" />
                </a>
              </li>
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}